import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { scrollToTop } from '../../_helpers/useful-functions';
import { get, post } from '../../core/client';
import { getLocalStorageItem, setLocalStorageItem } from '../../core/utility';
import { getLeftMenuList } from '../../store/features/hrDetail/hrDetailsSlice';
import EventsShareModal from './EventsShareModal';
import { isMacOs } from 'react-device-detect';
import { useAppSelector } from '../../store';
import { userId } from '../../_helpers/useful-functions';
import { useTranslation } from 'react-i18next';
import { toastMessage } from '@kocsistem/oneframe-react-bundle';

const EventDetail = (props: any) => {
    const [newsDetailData, setNewsDetailData] = useState(null);
    const [isNewsOpenModal, setIsNewsOpenModal] = useState<boolean>(false);
    const dispatch = useDispatch();
    const { urlName }: any = useAppSelector(state => state.hrDetails);

    const culture = getLocalStorageItem('SelectedLanguage');
    const { t } = useTranslation();
    const userIsLogin = getLocalStorageItem('isLogin')
    const history = useHistory();
    const _redirectAfterLogin = getLocalStorageItem("redirectAfterLogin");

    useEffect(() => {
        scrollToTop();
        dispatch(getLeftMenuList());
        if (props?.match?.params?.eventId) {
            const pageId = urlName?.items?.find(urlItem => urlItem.url === props?.match?.params?.eventId)?.id
            if (pageId)
                getNewsDetail(pageId);
        }
    }, [culture, urlName]);

    const getNewsDetail = async newId_ => {
        const userId = getLocalStorageItem('USER_ID');
        if (userIsLogin && userId) {

            await get<any>(`/event/get-event-details?eventId=${newId_}&userId=${userId}`).then(res => {
                if (res.isSuccessful) {

                    if (!res?.result?.isVisible) {
                        window.location.href = "/KocGonulluleriProjeleri";
                    }
                    setNewsDetailData(res?.result);
                    const id = res?.result?.eventId;
                    if ((!_redirectAfterLogin || _redirectAfterLogin === "") && id) {
                        setLocalStorageItem('redirectAfterLogin', "");
                    }
                    else if (!id) {
                        window.location.href = "/KocGonulluleriProjeleri";
                    }
                    else if ((_redirectAfterLogin || _redirectAfterLogin != "") && id && res?.result?.eventDetail[0]?.showJoinButton) {
                        setLocalStorageItem('redirectAfterLogin', "");
                        applyEvent(id);
                    }
                    else {
                        setLocalStorageItem('redirectAfterLogin', "");
                    }
                }
                else {

                    window.location.href = "/KocGonulluleriProjeleri";
                }
            });
        }
        else {
            await get<any>(`/event/get-event-details?eventId=` + newId_).then(res => {

                if (res.isSuccessful) {
                    if (!res?.result?.isVisible) {
                        window.location.href = "/KocGonulluleriProjeleri";
                    }
                    setNewsDetailData(res?.result);
                }
                else {
                    window.location.href = "/KocGonulluleriProjeleri";

                }
            });
        }
    };
    const applyEvent = async (eventId) => {

        if (userIsLogin) {
            // window.open(
            //     "https://khicindekocvar.blob.core.windows.net/cdn/prod/kvkk-kg.html",
            //     "_blank"
            // );
            setIsNewsOpenModal(true);
            const response = await post<any>(`/event/join-event`, { eventId: eventId, userId }, t("shared.save-success"));

            if (response && response.isSuccessful) {
                // window.location.href = "/events";

                toastMessage({
                    messageType: "success",
                    message: "Etkinliğe katıldınız",
                    position: "right",
                    overlay: true,
                    icon: "fad fa-exclamation-square",
                    timeout: 2000,
                });
                await get<any>(`/event/get-event-details?eventId=${eventId}&userId=${userId}`).then(res => {

                    if (res.isSuccessful) {
                        if (!res?.result?.isVisible) {
                            window.location.href = "/KocGonulluleriProjeleri";
                        }
                        setNewsDetailData(res?.result);
                    }
                    else {
                        window.location.href = "/KocGonulluleriProjeleri";

                    }
                });
            }

        }
        else {
            sessionStorage.setItem('kocgonulluleri', "true");
            setLocalStorageItem('redirectAfterLogin', window.location.pathname);
            setLocalStorageItem('SelectedLanguage', culture);
            history.push('/accounts/login');
        }
    };

    const handleViewAllProjects = () => {
            scrollToTop();
            history.push('/KocGonulluleriProjeleri');
    };

    return (
        <>
            <EventsShareModal newsModalData={newsDetailData} closeModal={() => setIsNewsOpenModal(false)} newsOpenModal={isNewsOpenModal} />
            <div className={isMacOs ? "news-detail-01 isMacOs" : "news-detail-01"} id="the-news-details">
                <Helmet>
                    <title>içinde Koç Var</title>
                    <meta name="description" content={`${newsDetailData?.eventDetail[0]?.text}`} />
                    <meta property="og:url" content={`${window?.location?.href}`} />
                    <meta property="og:type" content="website" />
                    <meta property="og:title" content={`${newsDetailData?.eventDetail[0]?.text}`} />
                    <meta property="og:description" content={`${newsDetailData?.eventDetail[0]?.title}`} />
                    <meta property="twitter:image" content={`${newsDetailData?.eventDetail[0]?.imageUrl}`} />
                    <meta property="og:image:secure_url" content={`${newsDetailData?.eventDetail[0]?.imageUrl}`} />
                    <meta property="og:image" content={`${newsDetailData?.eventDetail[0]?.imageUrl}`} />
                </Helmet>
                <div className="c-wrapper">
                <img loading="lazy" className="c-item-01" src={newsDetailData?.eventDetail[0]?.imageUrl} alt="Event Image" />
                <img loading="lazy" className="c-item-01-responsive" src={newsDetailData?.eventDetail[0]?.imageUrl} alt="Event Image" />
                    <div className="c-item">
                        <div className="c-item-02">
                            <h6 className="c-unit-01">{newsDetailData?.eventDetail[0]?.title}</h6>
                            {newsDetailData?.eventDetail[0]?.showJoinButton &&
                                <div className="store-icon-item-01">
                                    <a
                                        rel="noreferrer"
                                        className={new Date(newsDetailData?.releaseDate).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0) ? "applyButton-event" : "disabled-link applyButton-event"}
                                        onClick={() => new Date(newsDetailData?.releaseDate).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0) ? applyEvent(newsDetailData?.eventId) : ("#")}
                                        aria-label="Etkinliğe başvur"
                                    >
                                        Başvur
                                    </a>
                                </div>
                            }
                            {!newsDetailData?.eventDetail[0]?.showJoinButton &&
                                <div className="store-icon-item-01">
                                    <a className={"disabled-link applyButton-event"} rel="noreferrer"
                                        onClick={() => ("#")}
                                         aria-label="Başvuru alındı"
                                    >
                                        Başvurun Alındı
                                    </a>
                                </div>
                            }
                        </div>
                        <div className="c-item-03" dangerouslySetInnerHTML={{ __html: newsDetailData?.eventDetail[0]?.text }} />
                    </div>
                    <div style={{ textAlign: "center", marginTop: "20px" }}>
                        <a 
                            onClick={handleViewAllProjects}
                            className="all-events-show-button"
                            aria-label="Tüm projeleri görüntüle"
                        >
                            Tüm Projeleri Gör
                        </a>
                    </div>
                </div>
            </div >
        </>
    );
};

export default EventDetail;
